import React, { useEffect, useState } from 'react';
// import { useHistory } from "react-router-dom";
function ComplaintSubmit(props) {
  //   const history = useHistory();
  // const [status, setStatus] = useState(0);
  const [message, setMessage] = useState("");
  useEffect(() => {
    if (props.message) {
      setMessage(props.message)
    }

    if (props.status) {
      // setStatus(props.status)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="text-center">
      <div className="container payment-card" style={{ border: "1px solid grey" }}>
        
        <div style={{ borderRadius: 200, height: 200, width: 200, background: '#F8FAF5', margin: '0 auto' }}>
          <i className="checkmark">✓</i>
        </div>
          <h1>Success</h1>
          <p className={'payment-card-content text-primary'} >{message}</p>
      </div>
    </div>
  )
}

export default ComplaintSubmit;